import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import RESOURCES from './resources'
import { INTERNAL_HOST } from '@/commonConst'

const LOCAL_STORAGE_LANGUAGE_KEY = 'adeff-language'

const resolveLanguage = (language?: string | null) => {
  if (!language) {
    return ''
  }
  return Object.prototype.hasOwnProperty.call(RESOURCES, language) ? language : ''
}

const getStorageLanguage = () => {
  const storageLanguage = window.localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY)
  const rawLanguage = resolveLanguage(storageLanguage)
  if (rawLanguage) {
    return rawLanguage
  }

  if (!storageLanguage) {
    return ''
  }

  try {
    const parsedLanguage = JSON.parse(storageLanguage)
    if (typeof parsedLanguage === 'string') {
      return resolveLanguage(parsedLanguage)
    }
  } catch {
    // ignore invalid JSON and fallback to default language
  }

  return ''
}

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'en'
  }

  const storageLanguage = getStorageLanguage()
  if (storageLanguage) {
    return storageLanguage
  }

  return INTERNAL_HOST.includes(window.location.hostname) ? 'zh' : 'en'
}

i18n.use(initReactI18next).init({
  debug: false,
  resources: RESOURCES,
  lng: getInitialLanguage(),
  fallbackLng: 'en', // 当前语言的翻译缺失时的后备语言
  interpolation: {
    escapeValue: false, // react 已经确保转义
  },
})

export default i18n
